const categoryObjIimjobs = [
  { 
    name: 'Select Category', 
    id: -1, 
  },
  {
    name: "Banking & Finance",
    id: 13,
  },
  {
    name: "Sales & Marketing",
    id: 14,
  },
  {
    name: "Consulting",
    id: 16,
  },
  {
    name: "HR & IR",
    id: 17,
  },
  {
    name: "IT & Systems",
    id: 15,
  },
  {
    name: "SCM & Operations",
    id: 19,
  },
  {
    name: "Legal",
    id: 21,
  },
  {
    name: "BPO",
    id: 22,
  },
  {
    name: "Healthcare",
    id: 23,
  },
  {
    name: "Pharma",
    id: 24,
  },
  {
    name: "GenAI",
    id: 25,
  },
];

const categoryObjHirist = [
    { 
        "name": 'Select Category', 
        "id": -1 
    },
    {
        "id": "14",
        "name": "AI/ML"
    },
    {
        "name": "Data Analytics & BI",
        "id": "7"
    },
    {
        "id": "15",
        "name": "Data Engineering"
    },
    {
        "name": "Backend Development",
        "id": "1"
    },
    {
        "name": "Frontend Development",
        "id": "2"
    },
    {
        "id": "16",
        "name": "Full Stack"
    },
    {
        "name": "Mobile Applications",
        "id": "5"
    },
    {
        "name": "Emerging Technologies & Roles",
        "id": "9"
    },
    {
        "name": "DevOps / SRE",
        "id": "8"
    },
    {
        "id": "17",
        "name": "CyberSecurity"
    },
    {
        "name": "Quality Assurance",
        "id": "11"
    },
    {
        "name": "Platform Engineering / SAP/Oracle Jobs",
        "id": "6"
    },
    {
        "name": "Product Management",
        "id": "12"
    },
    {
        "name": "Business Analysis and Project Management",
        "id": "13"
    },
    {
        "name": "UI & Design",
        "id": "10"
    },
    {
        "name": "Semiconductor/VLSI/EDA",
        "id": "4"
    },
    {
        "name": "Others",
        "id": "3"
    }
]

const categoryObjUpdazz = [
    { id: -1,
      name: 'Select Category'
    },
    {
        id: "14",
        name: "BFSI Sales"
    },
    {
        id: "2",
        name: "B2B/Corporate Sales"
    },
    {
        id: "1",
        name: "B2C/Retail/Channel Sales"
    },
    {
        id: "11",
        name: "Online/Digital marketing"
    },
    {
        id: "5",
        name: "Telesales/Inside Sales/BPO"
    },
    {
        id: "15",
        name: "IT Sales"
    },
    {
        id: "9",
        name: "Marketing/PR/Advertising"
    },
    {
        id: "8",
        name: "After-Sales / Customer Service"
    },
    {
        id: "10",
        name: "Content/Design"
    },
    {
        id: "7",
        name: "Pre-Sales"
    },
    {
        id: "6",
        name: "Sales Management"
    }
]

export function getCategory() {
    switch(process.env.REACT_APP_PLATFORM) {
        case 'iimjobs':
            return categoryObjIimjobs
        case 'updazz':
            return categoryObjUpdazz
        default:
            return categoryObjHirist
    }
}

export function getCategoryPill() {
    const category = getCategory();
    const pillCategory = category.map(cat => ({
        text: cat['name'],
        key: cat['id'],
        value: `${cat['id']}`

    }))


    return pillCategory;
}

export function getCategoryMap() {
    let arr = [];
    if(process.env.REACT_APP_PLATFORM == 'iimjobs')
        arr = categoryObjIimjobs;
    else if(process.env.REACT_APP_PLATFORM == 'hirist')
        arr = categoryObjHirist
    else 
        arr = categoryObjUpdazz

    return arr.reduce((p,c) => {
        p[c.id] = c.name;
        return p;
    }, {})
}